import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CalendarModule } from 'angular-calendar';
import { DirectivesModule } from '../../theme/directives/directives.module';
import { ClientParentComponent } from './client-parent.component';
import { ClientParentRoutingModule } from './client-parent-routing.module';
import { MaskedTextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { ClientCreateEditComponent } from './client-create-edit/client-create-edit.component';
import { ClientListComponent } from './client-list/client-list.component';
import { ColumnChooserService, FilterService, GridModule, PageService, ResizeService, SortService } from '@syncfusion/ej2-angular-grids';
import { MyDatePickerModule } from 'mydatepicker';
import { ClientEmployeeContactModule } from '../client-employee-contact/client-employee-contact.module';
import { clientOnboardingListModule } from '../client-onboardinglist/client-onboardinglist.module';
import { clienttserivce } from './clienttservice';
import { clienttserivcetax } from './clientttaxservice';
import { ClientEmployeeRelationshipModule } from '../client-employee-relationship/client-employee-relationship.module';
import { ClientAuthorizationComponent } from './client-authorization/client-authorization.component';
import { BudgetimportModule } from '../budgetimport/budgetimport.module';
import { BudgetplanFormModule } from '../budgetplan-form/budgetplan-form.module';
import { PurchaseRequestModule } from '../purchase-request/purchase-request.module';
import { ClientNotesModule } from '../client-notes/client-notes.module';
import { ICD10Module } from '../icd10/icd10.module';
import { ClientEmployeeDynamicFormModule } from '../client-employee-dynamicform/client-employee-dynamicform.module';
import { ClientDocumentComponent } from './client-document/client-document.component';
import { NgxExtendedPdfViewerComponent, NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { PdfViewerModule } from 'ng2-pdf-viewer';import { DropDownListModule } from '@syncfusion/ej2-angular-dropdowns';

import { GoogleMapModule } from './google-map/google-map.module';
import { ClientSupportRelationComponent } from './client-support-relation/client-support-relation.component';
import { SupportplannerComponent } from '../supportplanner/supportplanner.component';
import { SupportplannerModule } from '../supportplanner/supportplanner.module';
import { EligibilityReportModule } from '../eligibility-report/eligibility-report.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    CalendarModule,
    DirectivesModule,
    ClientParentRoutingModule,
    MaskedTextBoxModule,
    GridModule,
    NgSelectModule,
    ReactiveFormsModule.withConfig({ warnOnNgModelWithFormControl: 'never' }),
    NgxUiLoaderModule,
    MyDatePickerModule,
    ClientEmployeeContactModule,
    clientOnboardingListModule,
    ClientEmployeeRelationshipModule,
    BudgetimportModule,
    BudgetplanFormModule,
    PurchaseRequestModule,
    ClientNotesModule,
    ICD10Module,
    ClientEmployeeDynamicFormModule,
    PdfViewerModule,
    NgxExtendedPdfViewerModule,
    DropDownListModule,
    GoogleMapModule,
    SupportplannerModule,
    EligibilityReportModule,
  ],
  declarations: [
    ClientParentComponent,
    ClientCreateEditComponent,
    ClientListComponent,
    ClientAuthorizationComponent,
    ClientDocumentComponent,
    ClientSupportRelationComponent,
    
    
  ],
  providers: [clienttserivcetax, clienttserivce, ColumnChooserService, PageService, SortService, FilterService, ResizeService],

})

export class ClientParentModule { }
